"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(reducers) {
    var returnMap = {};
    var _loop_1 = function (key) {
        // wrap reducers here
        if (reducers.hasOwnProperty(key)) {
            var reducer_1 = reducers[key];
            var wrappedReducer = function (state, action) {
                if (action['type'] == 'HYDRATE') {
                    // Every reducer must have a state.
                    // This state often takes the shape of a keyvalue pair
                    // As such assert the HYDRATE payload to have structure of key, value
                    var p = action['payload'];
                    state = p[key];
                }
                if (action.type === 'CLEAR_STATE') {
                    state = undefined;
                }
                return reducer_1(state, action);
            };
            returnMap[key] = wrappedReducer;
        }
    };
    for (var key in reducers) {
        _loop_1(key);
    }
    // return ReducerMap which has been modified but still appears intact to TypeScript
    return returnMap;
}
exports.default = default_1;
